import ConfirmModal from '@components/ui/Modal/ConfirmModal'
import UpdateConfirmModal from '@components/ui/Modal/UpdateConfirmModal'
import AnnouncementCoeffiDetailModal from './AnnouncementCoeffiDetailModal'
import ConfirmLoginModal from './ConfirmLoginModal'
import EmissionStandardModal from './EmissionStandardModal'
import ForgotPassowrdModal from './ForgotPassowrdModal'
import LanguageModal from './LanguageModal'
import LoginAnnounceModal from './LoginAnnounceModal'
import OrganizationListModal from './OrganizationListModal'
import PageNoPermissionModal from './PageNoPermissionModal'
import PowerInputConfirmModal from './PowerInputConfirmModal'
import RentalConfirmModal from './RentalConfirmModal'
import ResetPasswordModal from './ResetPasswordModal'
import SystemVersionModal from './SystemVersionModal'

interface IModal {
  LanguageModal: typeof LanguageModal
  SystemVersionModal: typeof SystemVersionModal
  ResetPasswordModal: typeof ResetPasswordModal
  ForgotPassowrdModal: typeof ForgotPassowrdModal
  RentalConfirmModal: typeof RentalConfirmModal
  ConfirmLoginModal: typeof ConfirmLoginModal
  ConfirmModal: typeof ConfirmModal
  OrganizationListModal: typeof OrganizationListModal
  UpdateConfirmModal: typeof UpdateConfirmModal
  PageNoPermissionModal: typeof PageNoPermissionModal
  // 係數大表
  AnnouncementCoeffiDetailModal: typeof AnnouncementCoeffiDetailModal
  // 新增再生能源提示
  PowerInputConfirmModal: typeof PowerInputConfirmModal
  // 登入公告資訊
  LoginAnnounceModal: typeof LoginAnnounceModal
  // 碳排標準 iso/ghg
  EmissionStandardModal: typeof EmissionStandardModal
}

const Modals: IModal = {
  OrganizationListModal,
  ConfirmModal,
  ConfirmLoginModal,
  LanguageModal,
  RentalConfirmModal,
  ResetPasswordModal,
  SystemVersionModal,
  ForgotPassowrdModal,
  UpdateConfirmModal,
  PageNoPermissionModal,
  AnnouncementCoeffiDetailModal,
  PowerInputConfirmModal,
  LoginAnnounceModal,
  EmissionStandardModal,
}

export default Modals
